import token, { tokenToVars } from '../token';
import Switch from './switch';

export { Switch };
export default tokenToVars(Switch, token);
